/**
 * Box-based pricing:
 *   item.wholesaleUnit  = box size (e.g. 48)
 *   item.wholesalePrice = price per unit inside a full box
 *   item.price          = retail price per unit
 *
 * Example: qty=50, unit=48, wholesale=500, retail=650
 *   → 1 box × 48 × 500 ₽ + 2 × 650 ₽ = 25 300 ₽
 */

export function calcTotal(item) {
  if (!item.price) return null
  if (!item.wholesaleUnit || !item.wholesalePrice) {
    return item.price * item.qty
  }
  const boxes     = Math.floor(item.qty / item.wholesaleUnit)
  const remainder = item.qty % item.wholesaleUnit
  return boxes * item.wholesaleUnit * item.wholesalePrice + remainder * item.price
}

/** Returns a human-readable breakdown string, or null if no box logic applies. */
export function calcBreakdown(item) {
  if (!item.wholesaleUnit || !item.wholesalePrice || !item.price) return null
  const boxes     = Math.floor(item.qty / item.wholesaleUnit)
  const remainder = item.qty % item.wholesaleUnit
  if (boxes === 0) return null
  const parts = [`${boxes} кор. × ${item.wholesaleUnit} шт. × ${item.wholesalePrice} ₽`]
  if (remainder > 0) parts.push(`${remainder} шт. × ${item.price} ₽`)
  return parts.join(' + ')
}

/** Live preview for modal row: e.g. "= 25 300 ₽ (1 кор. + 2 шт.)" */
export function calcPreview(row, qty) {
  if (!row.price) return null
  if (!row.wholesaleUnit || !row.wholesalePrice) {
    return `= ${(row.price * qty).toLocaleString('ru')} ₽`
  }
  const boxes     = Math.floor(qty / row.wholesaleUnit)
  const remainder = qty % row.wholesaleUnit
  const total     = boxes * row.wholesaleUnit * row.wholesalePrice + remainder * row.price
  const parts = []
  if (boxes > 0)     parts.push(`${boxes} кор.`)
  if (remainder > 0) parts.push(`${remainder} шт.`)
  return `= ${total.toLocaleString('ru')} ₽` + (parts.length ? ` (${parts.join(' + ')})` : '')
}
